import React, { useEffect, useState, useMemo } from "react";
import { Tree } from "antd";
import "antd/dist/reset.css";
import { fetchData } from "../../features/fetch/fetchSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  cleanSelectedLeafObj,
  setSelectedLeafObj,
} from "../../features/obj/objSlice";
import DataSetTable from "./DataSetTable";
import { getPreviousFinancialYr, numberWithCommas } from "../../utils";
import TableLoading from "../../components/TableLoading";

const DynamicTreeAndTable = () => {
  const dispatch = useDispatch();
  const urlTree = "api/v1/bread/getPageCategoryBread";
  const urlTable = "api/v2/public/fetchFormGenerate";

  const { dataTree, filterObj, dataTable, selectedLeaf, loading } = useSelector(
    (state) => ({
      filterObj: state.obj.filterObj,
      dataTree: state.fetch.data[urlTree] || [],
      dataTable: state.fetch.data[urlTable] || [],
      selectedLeaf: state.obj.selectedLeaf,
      loading: state.fetch.loading,
    })
  );

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [tableData, setTableData] = useState([]);

  const transformTreeData = (nodes, parent = null) => {
    if (!Array.isArray(nodes)) return [];
    return nodes.map((node) => {
      const transformedNode = {
        title: node?.text,
        key: node?.id,
        isLeaf: node?.leaf,
        rawData: node,
        parent,
      };
      if (node?.children) {
        transformedNode.children = transformTreeData(
          node?.children,
          transformedNode
        );
      }
      return transformedNode;
    });
  };
  const [tableLoading, setTableLoading] = useState(false);

  const onSelect = (keys, { node }) => {
    setSelectedKeys(keys);
    setTableData([]);
    dispatch(cleanSelectedLeafObj());

    if (!node?.isLeaf) return;

    dispatch(
      setSelectedLeafObj({
        title: node?.rawData?.pageName,
        subTitle: node.rawData?.text,
        scId: node?.rawData?.warisSchemeId,
        znId: node?.rawData?.warisZoneId,
      })
    );

    const payload = {
      url: urlTable,
      pgName_id: node?.rawData?.pageName ?? node?.rawData?.text,
      v_wsp_id: "74",
      v_tdYear: filterObj?.code,
      v_tdQtr: filterObj?.quarter,
      v_mnCode: filterObj?.month,
      scId: node?.rawData?.warisSchemeId || null,
      znId: node?.rawData?.warisZoneId || null,
      datasetDtls_id: filterObj?.datasetDtls_id || null,
      pDataRqType: filterObj?.fsType,
    };
    setTableLoading(true);
    dispatch(fetchData(payload)).then((res) => {
      setTableData(res.payload?.data || []);
      setTableLoading(false);
    });
  };

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlTree,
        dscYear: filterObj?.code,
        instTypeName: null,
        mnCode: null,
        node: "root",
        pdataRqType: filterObj?.fsType,
        quarter: filterObj?.quarter,
      })
    );
    setTableData([]);
  }, [
    filterObj,
    filterObj?.code,
    filterObj?.fsType,
    filterObj?.quarter,
    dispatch,
  ]);

  useEffect(() => {
    setExpandedKeys([]);
    setSelectedKeys([]);
  }, [dataTree]);
  const tableColumns = useMemo(() => {
    const freqType = filterObj?.fsType?.toLowerCase() || "";

    let columns = [
      // { title: "PpId", dataIndex: "ppId", key: "ppId" },
      //  { title: "Operations", dataIndex: "ppOperations", key: "ppOperations" },
      {
        title: "",
        dataIndex: "ppColName",
        key: "ppColName", 
      },
      { title: "Unit", dataIndex: "ppUnit", key: "ppUnit" },
    ];

    if (freqType === "monthly") {
      if (selectedLeaf?.title === "Billing") {
        columns.push({
          title: `${filterObj?.month || ""}`,
          dataIndex: "tdM1Value",
          key: "tdM1Value",
          editable: true,
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
        });
        //   columns.push({
        //   title: "Adjustment",
        //   dataIndex: "tdM1Value",
        //   key: "tdM1Value",
        // });
      } else {
        columns.push({
          title: `${filterObj?.month || ""}`,
          dataIndex: "tdM1Value",
          key: "tdM1Value",
          editable: true,
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
        });
      }
    } else if (freqType === "quarterly") {
      const months = filterObj?.monthsInQuarter || [];
      columns.push(
        {
          title: months[0] || "Month 1",
          dataIndex: "tdM1Value",
          key: "tdM1Value",
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
        },
        {
          title: months[1] || "Month 2",
          dataIndex: "tdM2Value",
          key: "tdM2Value",
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
        },
        {
          title: months[2] || "Month 3",
          dataIndex: "tdM3Value",
          key: "tdM3Value",
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
        }
      );
    } else if (freqType === "annual") {
      columns.push(
        {
          title: `Current ${filterObj?.financialYr || ""}`,
          dataIndex: "tdValue",
          key: "tdValue",
          render: (item) => {
            return <div>{numberWithCommas(item)}</div>;
          },
          editable: true,
        }

        // {
        //   title: `Previous ${getPreviousFinancialYr(filterObj?.financialYr)}`,
        //   dataIndex: "prevYearVvalue",
        //   key: "prevYearVvalue",
        // }
      );
    }

    return columns;
  }, [filterObj?.fsType, selectedLeaf]);
  // console.log("filterObj",filterObj)
  return (
    <div className="flex lg:flex-row flex-col w-full gap-[1rem]">
      <div className="bg-white px-[1.5rem] py-[2.25rem] dataset-card w-[300px] min-h-[75vh] max-h-[75vh] overflow-y-auto">
        {dataTree?.length > 0 &&
        ((filterObj?.fsType !== "MONTHLY" &&
          filterObj?.fsType !== "QUARTERLY") ||
          (filterObj?.fsType === "MONTHLY" && filterObj?.month) ||
          (filterObj?.fsType === "QUARTERLY" && filterObj?.quarter)) ? (
          <Tree
            showLine={{ showLeafIcon: false }}
            expandedKeys={expandedKeys}
            onExpand={setExpandedKeys}
            selectedKeys={selectedKeys}
            onSelect={onSelect}
            treeData={transformTreeData(dataTree)}
          />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500 italic border border-dashed rounded-lg p-4">
            No Data Available
          </div>
        )}
      </div>

      <div className="w-full bg-white px-[2.25rem] py-[1.5rem] dataset-card min-h-[75vh] max-h-[75vh] overflow-y-auto">
        {tableLoading ? (
          <TableLoading />
        ) : (
          <>
            {tableData?.length > 0 ? (
              <DataSetTable
                columns={tableColumns}
                dataSource={tableData}
                setTableData={setTableData}
                originalData={dataTable}
              />
            ) : (
              <div className="flex items-center justify-center h-full text-gray-500 italic border border-dashed rounded-lg p-4">
                No Table Data Available
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DynamicTreeAndTable;
